module.exports = __webpack_public_path__ + "img/webase4.89eba322.png";